import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const ScheduleModal = ({
  ismodal,
  setModal,
  selectedscheduleorder,
  selectedOrders,
  setSelectedOrders,
  orderOptions,
  scheduleappointment,
}) => {
  if (!ismodal) return null;

  // const filteredOrders = orderOptions.filter(
  //   (order) =>
  //     order.schedule === "t" &&
  //     order.ordertype !== "Prescription" &&
  //     order.ordertype !== "Notes"
  // );
const filteredOrders = orderOptions.filter((order) => {
  const isScheduleTrue = order.schedule === "t";
  const isScheduleFalseWithRTO = order.schedule === "f" && order.ordertype === "Schedule-RTO";
  const isValidType = order.ordertype !== "Prescription" && order.ordertype !== "Notes";

  return (isScheduleTrue || isScheduleFalseWithRTO) && isValidType;
});


  const isOrderSelected = (order) =>
    selectedOrders.some((o) => o.id === order.id);

  const handleCheckboxChange = (order) => {
    setSelectedOrders((prevSelected) =>
      isOrderSelected(order)
        ? prevSelected.filter((o) => o.id !== order.id)
        : [...prevSelected, order]
    );
  };

  const handleCreateAppointment = () => {
   scheduleappointment()
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div className="bg-white w-[90%] max-w-md rounded-lg p-4 shadow-lg relative">
        {/* Close Icon */}
        <button
          onClick={() => setModal(false)}
          className="absolute top-3 right-3 text-gray-600 hover:text-black"
        >
          <FontAwesomeIcon icon={faTimes} size="lg" />
        </button>

        {/* Heading */}
        <h2 className="text-lg font-semibold mb-4 text-gray-800">
          Select Orders to Schedule
        </h2>

        {/* Order List */}
        <div className="space-y-3 max-h-[300px] overflow-y-auto">
          {filteredOrders
  .filter((order) => order.status !== 'COMPLETED')
  .map((order) => (
    <div
      key={order.id}
      className="flex justify-between items-center border p-2 rounded-md"
    >
      <span className="text-sm text-gray-800 font-medium truncate">
        {order.ordername}
      </span>
      <input
        type="checkbox"
        checked={isOrderSelected(order)}
        onChange={() => handleCheckboxChange(order)}
        className="w-4 h-4 text-blue-600"
      />
    </div>
))}

        </div>

        {/* Create Appointment Button */}
        <button
          onClick={handleCreateAppointment}
          className="mt-5 w-full bg-[#E17954] font-inter text-white py-2 rounded-md text-sm shadow-sm hover:opacity-90 transition"
        >
          Create Appointment
        </button>
      </div>
    </div>
  );
};

export default ScheduleModal;
